export default __webpack_public_path__ + "static/media/folder.284b44d6.svg";